// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__bvAuC","question":"Question_question__1OLt-","description":"Question_description__1qPvZ"};